import { forwardRef, type Ref, type SVGProps } from "react";
const IconChevronLeftOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="m20.716 28.215-12.29-12.29 12.28-12.29a1 1 0 0 0-1.41-1.41l-13 13a1 1 0 0 0 0 1.42l13 13a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.43"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconChevronLeftOutlineSVG);
ForwardRef.displayName = "IconChevronLeftOutline";
export { ForwardRef as IconChevronLeftOutline };
